import { LitElement, html, animate, scroll } from '@hh/global.js'

class StackingSpotlight extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.initScrollAnimate()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  isMobile() {
    return !window.matchMedia('(min-width: 768px)').matches
  }

  initScrollAnimate() {
    if (this.isMobile()) return

    const rowEls = this.querySelectorAll('.js-spotlight-row')

    rowEls?.forEach((el, i) => {
      if (i === rowEls.length - 1) return;

      const finalScale = 1 - (rowEls.length - i) * 0.05
      scroll(
        animate(el, {
          scale: [1, finalScale],
        }),
        {
          target: rowEls[i + 1],
          offset: ["0.5 1", "1 1"],
        }
      )
    })
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('stacking-spotlight', StackingSpotlight)
